export const AppPaths = {
  SIGN_IN: "/sign-in",

  HOME: "/",
  HOME_ALL: "/*",

  Profile: "/profile",
  ProfileView: "/profile/view",
  Profile_All: "/profile/*",

  Patients_All: "/patients/*",
  Patients: "/patients",

  ToDo: "/to-do",
  ToDo_All: "/to-do/*",
  ToDo_Calendar: "/to-do",
  ToDo_Calendar_Short: "/",
  Todo_Users: "/to-do/users",
  Todo_Users_Short: "/users",

  Patients_List: "/patients/list",
  Patients_List_Short: "/list",

  Patients_View: "/patients/view",
  Patients_View_Short: "/view",
  PatientsView_Background: "/patients/view/:userId/background",
  PatientsView_Background_Short: "/background",
  PatientsView_ExercisePlan: "/patients/view/:userId/exercise-plan",
  PatientsView_ExercisePlan_Short: "/exercise-plan",
  PatientsView_Statistics: "/patients/view/:userId/statistics",
  PatientsView_Statistics_Short: "/statistics",
  PatientsView_Feedback: "/patients/view/:userId/feedback",
  PatientsView_Feedback_Short: "/feedback",

  CalendarEntries_All: "/calendar-entries/*",
  CalendarEntries_View: "/calendar-entries/view/:entryId",

  Patients_New: "/patients/new",
  Patients_New_Short: "/new",

  Patients_Edit: "/patients/edit",
  Patients_Edit_Short: "/edit",

  CHATS_ALL: "/chats/*",
  CHATS_SINGLE: "/chats/:id",
  CHATS: "/chats",

  Calendar: "/calendar",
  Calendar_All: "/calendar/*",

  Settings_All: "/settings/*",
  Settings: "/settings",
  PatientsView_Overview: "/patients/view/:userId/overview",
  PatientsView_Overview_Short: "/overview",
} as const;
